import SeoHead from '../components/SeoHead';

export default function AffiliateTerms() {
  return (
    <>
      <SeoHead title="Affiliate Terms — AI Ghostwriter Pro" />
      <section className="pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <h1 className="font-serif text-4xl md:text-5xl leading-tight tracking-tight mb-8">
            Affiliate <span className="text-primary">Terms & Conditions</span>
          </h1>

          <div className="space-y-8 text-muted-foreground leading-relaxed">
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">1. Program Overview</h2>
              <p>The AI Ghostwriter Pro Affiliate Program allows approved participants to earn commissions by referring customers to our ghostwriting services.</p>
            </div>
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">2. Commission Structure</h2>
              <p>Commissions are earned on completed purchases made through your unique referral link. Rates start at 10% (Bronze) and scale to 25% (Platinum) based on total referrals.</p>
            </div>
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">3. Cookie Duration</h2>
              <p>Referral cookies last 90 days from the initial click. If a referred visitor purchases within this window, you receive credit for the sale.</p>
            </div>
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">4. Payout Terms</h2>
              <p>Minimum payout threshold is $50. Payouts are processed monthly. Affiliates can request payouts via their dashboard once the minimum is met.</p>
            </div>
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">5. Prohibited Activities</h2>
              <p>Self-referrals, misleading advertising, trademark bidding (PPC on "AI Ghostwriter Pro"), and spam are strictly prohibited and will result in account termination.</p>
            </div>
            <div>
              <h2 className="font-serif text-xl text-foreground mb-3">6. Termination</h2>
              <p>Either party may terminate the affiliate relationship at any time. Pending commissions for legitimate sales will still be paid upon termination.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
